import React from 'react';
import '../../App.css';
import MrBillRegister from '../MrBillReport';
function MrBillingRegisterPage({ sessionObject }) {
    return (
        <div className="page-mr">
            <MrBillRegister sessionObject={sessionObject} />
        </div>
    );
}

export default MrBillingRegisterPage;